
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33801',
  depVersions: {
  "documents-public-ui": "static-1.33801",
  "client-types": "static-1.443",
  "documents-lib": "static-1.33806",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1840",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5310",
  "hs-test-utils": "static-1.7704",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11142",
  "I18n": "static-7.1549",
  "jasmine-immutable": "static-1.2738",
  "jasmine-runner": "static-1.6175",
  "lodash": "static-1.3",
  "quartz": "static-1.6606",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16352",
  "reporting-data": "static-1.66210",
  "reporting-testing-lib": "static-1.8143",
  "reporting-visualizations": "static-1.58286",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4464",
  "webpack-env": "static-1.54",
  "atom": "static-1.4790",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2186",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.708",
  "customer-data-filters-ui": "static-1.38617",
  "customer-data-objects": "static-1.7335",
  "customer-data-property-utils": "static-1.7790",
  "data-fetching-client": "static-1.9396",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4252",
  "flux-actions": "static-1.299",
  "FormsCommonComponents": "static-1.85099",
  "FormUrlGenerator": "static-2.4450",
  "foundations-components": "static-1.7360",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11450",
  "icons": "static-2.615",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6863",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3579",
  "property-translator": "static-1.5133",
  "quartz-config": "static-1.384",
  "quartz-core": "static-1.5825",
  "quick-fetch": "static-1.3656",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5102",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7880",
  "reference-resolvers-lite": "static-1.7809",
  "report-customization-components": "static-1.12287",
  "reporting-enablement": "static-1.21829",
  "reporting-reports": "static-1.65888",
  "reporting-snowflake": "static-1.54828",
  "reporting-ui-components": "static-2.63482",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4327",
  "sales-content-partitioning": "static-1.8654",
  "SalesContentIndexUI": "static-3.8782",
  "sanitize": "static-1.4194",
  "sanitize-text": "static-1.7859",
  "self-service-api": "static-1.9947",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1464",
  "signup-constants": "static-1.18245",
  "signup-ui-lego-core": "static-1.20255",
  "signup-ui-url-generator": "static-2.7754",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4492",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10714",
  "ui-addon-i18n": "static-1.10848",
  "ui-addon-react-router-dom": "static-1.9265",
  "ui-addon-upgrades": "static-9.17478",
  "ui-asset-management-lib": "static-1.10598",
  "ui-images": "static-2.1068",
  "UIComponents": "static-3.8089",
  "usage-tracker": "static-1.7053",
  "usage-tracker-container": "static-1.7043",
  "usage-tracker-core": "static-1.6903",
  "usage-tracker-public": "static-1.6864",
  "viral-links-lib": "static-1.6743",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3154",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2883",
  "quartz-webpack": "static-1.2830",
  "ai-components-ui-library": "static-1.8156",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4551",
  "foundations-theming": "static-1.4124",
  "quartz-auth": "static-1.281",
  "usage-tracker-session-replay": "static-1.4739",
  "foundations-theming-base": "static-1.3109",
  "HeadJS": "static-2.696",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2815",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4051",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7644",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3387",
  "persist-promise": "static-1.3406",
  "reporting-client-types": "static-1.2356",
  "hs-story-utils": "static-1.9146",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9280",
  "hubspotter-http": "static-1.4405",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6969",
  "crm-message-bus": "static-1.42138",
  "customer-data-filters-ui-msw-helpers": "static-1.21051",
  "customer-data-objects-ui-components": "static-1.12721",
  "customer-data-reference-ui-components": "static-1.12858",
  "customer-data-ui-utilities": "static-1.9544",
  "framework-builder-read-service-client": "static-1.3774",
  "framework-data-schema-quick-fetch": "static-1.6492",
  "framework-data-schema-resolvers": "static-1.6587",
  "inbound-db-properties-service-client": "static-1.3605",
  "multi-account-reference-resolvers": "static-1.687",
  "onboarding-tours": "static-1.16160",
  "reporting-datasets-permissions-lib": "static-1.12825",
  "ui-addon-teams": "static-1.21126",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67411",
  "customer-data-properties": "static-1.50558",
  "forms-ai-lib": "static-1.3877",
  "forms-utils-lib": "static-1.12030",
  "foundations-components-test-utils": "static-1.4843",
  "react-dnd-compat": "static-1.4342",
  "react-tinymce": "static-1.54429",
  "tinymce-config": "static-2.53555",
  "ui-gdpr-components": "static-1.10065",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3629",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1005",
  "ui-fonts": "static-1.404",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.777",
  "mobile-manifest-mixins": "static-1.469",
  "quartz-head": "static-1.271",
  "quartz-i18n": "static-1.281",
  "quartz-routing": "static-1.36",
  "quartz-test": "static-1.281",
  "batch-promise": "static-1.1249",
  "external-options-client-types": "static-1.3910",
  "react-colorpicker": "static-2.9931",
  "copilot-toolkit": "static-1.10343",
  "data-quality-ui-library": "static-1.12150",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40461",
  "reporting-insights-lib": "static-1.955",
  "reporting-plugins": "static-1.9885",
  "ui-addon-draggable-compat": "static-2.3973",
  "ui-addon-opt": "static-4.8108",
  "ui-shepherd-react": "static-3.9862",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24519",
  "hubspot-apollo-client": "static-1.4599",
  "sales-templates-service-types-lib": "static-1.3919",
  "ui-business-units-lib": "static-1.8741",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5356",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3831",
  "upgrade-management-service-types": "static-1.4227",
  "timezone-utils": "static-2.4963",
  "bender-build-tools": "static-1.2847",
  "chatspot-core": "static-1.20049",
  "chirp-fetch": "static-1.1600",
  "bend-plugin-foundations-theming": "static-1.2607",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9278",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3550",
  "crm-pipelines-api-client-types": "static-1.3891",
  "multi-currency-client-types": "static-1.3445",
  "getting-started-shared-tasks": "static-1.17681",
  "growth-data-modal": "static-1.5053",
  "growth-onboarding-confetti": "static-1.2771",
  "growth-onboarding-next-action-utils": "static-1.1214",
  "navigation-components": "static-1.17050",
  "onboarding-tours-client": "static-1.4374",
  "onboarding-tours-utils": "static-1.226",
  "ui-shepherd-tracker": "static-1.7243",
  "ui-universal-auth": "static-1.8592",
  "user-context": "static-1.4814",
  "cms-field-types": "static-1.4526",
  "content-icons-ui": "static-1.2127",
  "integrations-lib": "static-1.15185",
  "calling-global-api": "static-1.63424",
  "calling-internal-common": "static-1.31008",
  "calling-lifecycle-internal": "static-1.64806",
  "calling-lifecycle-messages": "static-1.57100",
  "commerce-products-lib": "static-1.8625",
  "crm-links": "static-1.5970",
  "file-manager-components": "static-1.22674",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.381",
  "inbounddb-objects-service-types": "static-1.3977",
  "meetings-icalendar-utils-lib": "static-1.353",
  "object-builder-ui-client": "static-1.47739",
  "pipeline-validation-client-types": "static-1.3714",
  "property-value-citations": "static-1.1172",
  "pulse": "static-1.215",
  "smart-property-lib": "static-1.5640",
  "tiered-pricing": "static-1.710",
  "ui-addon-iframeable": "static-1.8740",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19329",
  "tinymce-themes": "static-1.55525",
  "data-token-picker": "static-1.15926",
  "hub-http-contrib": "static-1.2764",
  "interframe": "static-3.4511",
  "tinymce-data": "static-1.39640",
  "tinymce-plugins": "static-1.56669",
  "ui-addon-sales-email": "static-1.4932",
  "magpie-lib": "static-1.5295",
  "magpie-types": "static-1.4755",
  "simple-logging-lib": "static-1.2770",
  "content-assistance-lib": "static-1.7337",
  "dashboard-lib": "static-1.80334",
  "ExportDialog": "static-6.10107",
  "hubspot-prosemirror": "static-1.17398",
  "hubspot-prosemirror-plugins": "static-1.17390",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8409",
  "campaign-roi-lib": "static-1.8062",
  "feedback-loader": "static-1.28716",
  "commerce-analytics-service-client": "static-1.3409",
  "onboarding-scopes": "static-1.6163",
  "apollo-link-hub-http": "static-2.4368",
  "hubspot-apollo-cache": "static-1.58",
  "growth-monetization-service-types": "static-1.4243",
  "nav-client-types": "static-1.2051",
  "purchase-motions-api": "static-1.5359",
  "trials-service-types": "static-1.3644",
  "chatspot-client-types": "static-1.10377",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.445",
  "getting-started-shared-tasks-store": "static-1.16799",
  "integrations-error-boundary-lib": "static-1.12600",
  "integrations-tracking-lib": "static-1.5302",
  "native-integrations-shared-strings": "static-1.7508",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10091",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31014",
  "shared-worker-versioning": "static-1.10737",
  "calling-usage-tracker": "static-1.6257",
  "calling-orchestration-shared-library": "static-1.34578",
  "customer-data-tracking": "static-1.6581",
  "products-iframe-lib": "static-1.7133",
  "products-ui-components-shared-msw-handlers": "static-1.9662",
  "location-customization-utils-lib": "static-1.8329",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3874",
  "video-components-external": "static-1.10337",
  "video-data-lib": "static-1.33995",
  "directed-graph": "static-1.655",
  "event-emitter": "static-1.644",
  "breeze-intelligence-kit": "static-1.5208",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9363",
  "fsm": "static-1.3451",
  "policy-lib": "static-1.6520",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9426",
  "navigation-messaging": "static-1.6377",
  "FileManagerLib": "static-1.38314",
  "NamespacedHubStyle": "static-2.8825",
  "FileManagerCore": "static-1.38173",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11899",
  "layout-dnd-utils": "static-1.10874",
  "react-codemirror": "static-1.10325",
  "ui-addon-emoji-picker": "static-1.9608",
  "ui-brand-identity-lib": "static-1.13510",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27752",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8285",
  "payment-link-components": "static-1.22732",
  "EmailSignatureEditor": "static-1.23799",
  "eligibility-engine-service-types": "static-1.2925",
  "universal-page-editor-lib": "static-1.2715",
  "calling-orchestration-schema": "static-1.34803",
  "sales-views-client-types": "static-1.4013",
  "crm-record-cards-service-types": "static-1.3378",
  "content-media-composition-data-lib": "static-1.11177",
  "content-media-compositions": "static-2.15184",
  "media-bridge-lib": "static-1.18448",
  "trellis-story-utils": "static-1.4241",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5502",
  "FileManagerImages": "static-1.35825",
  "video-components": "static-1.12340",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4252",
  "video-embed": "static-1.34829",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67486",
  "layout-data-lib": "static-1.9199",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6304",
  "commerce-tours-lib": "static-1.5602",
  "growth-onboarding-reliability": "static-1.4808",
  "sales-checkout-service-client": "static-1.3421",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21165",
  "sales-email-signature-service-client": "static-1.3562",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21132",
  "outpost": "static-1.3931",
  "advanced-menus-core": "static-1.14689",
  "advanced-menus-lib": "static-1.11678",
  "ui-memberships-settings-lib": "static-1.33236",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14688",
  "simple-menus-lib": "static-1.16205"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33801",
  "client-types": "/client-types/static-1.443",
  "documents-lib": "/documents-lib/static-1.33806",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1840",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5310",
  "hs-test-utils": "/hs-test-utils/static-1.7704",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11142",
  "I18n": "/I18n/static-7.1549",
  "jasmine-immutable": "/jasmine-immutable/static-1.2738",
  "jasmine-runner": "/jasmine-runner/static-1.6175",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6606",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16352",
  "reporting-data": "/reporting-data/static-1.66210",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8143",
  "reporting-visualizations": "/reporting-visualizations/static-1.58286",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4464",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4790",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2186",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.708",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38617",
  "customer-data-objects": "/customer-data-objects/static-1.7335",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7790",
  "data-fetching-client": "/data-fetching-client/static-1.9396",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4252",
  "flux-actions": "/flux-actions/static-1.299",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85099",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4450",
  "foundations-components": "/foundations-components/static-1.7360",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11450",
  "icons": "/icons/static-2.615",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6863",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3579",
  "property-translator": "/property-translator/static-1.5133",
  "quartz-config": "/quartz-config/static-1.384",
  "quartz-core": "/quartz-core/static-1.5825",
  "quick-fetch": "/quick-fetch/static-1.3656",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5102",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7880",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7809",
  "report-customization-components": "/report-customization-components/static-1.12287",
  "reporting-enablement": "/reporting-enablement/static-1.21829",
  "reporting-reports": "/reporting-reports/static-1.65888",
  "reporting-snowflake": "/reporting-snowflake/static-1.54828",
  "reporting-ui-components": "/reporting-ui-components/static-2.63482",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4327",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8654",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8782",
  "sanitize": "/sanitize/static-1.4194",
  "sanitize-text": "/sanitize-text/static-1.7859",
  "self-service-api": "/self-service-api/static-1.9947",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1464",
  "signup-constants": "/signup-constants/static-1.18245",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20255",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7754",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4492",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10714",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10848",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9265",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17478",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10598",
  "ui-images": "/ui-images/static-2.1068",
  "UIComponents": "/UIComponents/static-3.8089",
  "usage-tracker": "/usage-tracker/static-1.7053",
  "usage-tracker-container": "/usage-tracker-container/static-1.7043",
  "usage-tracker-core": "/usage-tracker-core/static-1.6903",
  "usage-tracker-public": "/usage-tracker-public/static-1.6864",
  "viral-links-lib": "/viral-links-lib/static-1.6743",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3154",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2883",
  "quartz-webpack": "/quartz-webpack/static-1.2830",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8156",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4551",
  "foundations-theming": "/foundations-theming/static-1.4124",
  "quartz-auth": "/quartz-auth/static-1.281",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4739",
  "foundations-theming-base": "/foundations-theming-base/static-1.3109",
  "HeadJS": "/HeadJS/static-2.696",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2815",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4051",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7644",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3387",
  "persist-promise": "/persist-promise/static-1.3406",
  "reporting-client-types": "/reporting-client-types/static-1.2356",
  "hs-story-utils": "/hs-story-utils/static-1.9146",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9280",
  "hubspotter-http": "/hubspotter-http/static-1.4405",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6969",
  "crm-message-bus": "/crm-message-bus/static-1.42138",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21051",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12721",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12858",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9544",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3774",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6492",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6587",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3605",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.687",
  "onboarding-tours": "/onboarding-tours/static-1.16160",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12825",
  "ui-addon-teams": "/ui-addon-teams/static-1.21126",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67411",
  "customer-data-properties": "/customer-data-properties/static-1.50558",
  "forms-ai-lib": "/forms-ai-lib/static-1.3877",
  "forms-utils-lib": "/forms-utils-lib/static-1.12030",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4843",
  "react-dnd-compat": "/react-dnd-compat/static-1.4342",
  "react-tinymce": "/react-tinymce/static-1.54429",
  "tinymce-config": "/tinymce-config/static-2.53555",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10065",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3629",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1005",
  "ui-fonts": "/ui-fonts/static-1.404",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.777",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.469",
  "quartz-head": "/quartz-head/static-1.271",
  "quartz-i18n": "/quartz-i18n/static-1.281",
  "quartz-routing": "/quartz-routing/static-1.36",
  "quartz-test": "/quartz-test/static-1.281",
  "batch-promise": "/batch-promise/static-1.1249",
  "external-options-client-types": "/external-options-client-types/static-1.3910",
  "react-colorpicker": "/react-colorpicker/static-2.9931",
  "copilot-toolkit": "/copilot-toolkit/static-1.10343",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12150",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40461",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.955",
  "reporting-plugins": "/reporting-plugins/static-1.9885",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3973",
  "ui-addon-opt": "/ui-addon-opt/static-4.8108",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9862",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24519",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4599",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3919",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8741",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5356",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3831",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4227",
  "timezone-utils": "/timezone-utils/static-2.4963",
  "bender-build-tools": "/bender-build-tools/static-1.2847",
  "chatspot-core": "/chatspot-core/static-1.20049",
  "chirp-fetch": "/chirp-fetch/static-1.1600",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2607",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9278",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3550",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3891",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3445",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17681",
  "growth-data-modal": "/growth-data-modal/static-1.5053",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2771",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1214",
  "navigation-components": "/navigation-components/static-1.17050",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4374",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.226",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7243",
  "ui-universal-auth": "/ui-universal-auth/static-1.8592",
  "user-context": "/user-context/static-1.4814",
  "cms-field-types": "/cms-field-types/static-1.4526",
  "content-icons-ui": "/content-icons-ui/static-1.2127",
  "integrations-lib": "/integrations-lib/static-1.15185",
  "calling-global-api": "/calling-global-api/static-1.63424",
  "calling-internal-common": "/calling-internal-common/static-1.31008",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64806",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57100",
  "commerce-products-lib": "/commerce-products-lib/static-1.8625",
  "crm-links": "/crm-links/static-1.5970",
  "file-manager-components": "/file-manager-components/static-1.22674",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.381",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3977",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.353",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47739",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3714",
  "property-value-citations": "/property-value-citations/static-1.1172",
  "pulse": "/pulse/static-1.215",
  "smart-property-lib": "/smart-property-lib/static-1.5640",
  "tiered-pricing": "/tiered-pricing/static-1.710",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8740",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19329",
  "tinymce-themes": "/tinymce-themes/static-1.55525",
  "data-token-picker": "/data-token-picker/static-1.15926",
  "hub-http-contrib": "/hub-http-contrib/static-1.2764",
  "interframe": "/interframe/static-3.4511",
  "tinymce-data": "/tinymce-data/static-1.39640",
  "tinymce-plugins": "/tinymce-plugins/static-1.56669",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4932",
  "magpie-lib": "/magpie-lib/static-1.5295",
  "magpie-types": "/magpie-types/static-1.4755",
  "simple-logging-lib": "/simple-logging-lib/static-1.2770",
  "content-assistance-lib": "/content-assistance-lib/static-1.7337",
  "dashboard-lib": "/dashboard-lib/static-1.80334",
  "ExportDialog": "/ExportDialog/static-6.10107",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17398",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17390",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8409",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8062",
  "feedback-loader": "/feedback-loader/static-1.28716",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3409",
  "onboarding-scopes": "/onboarding-scopes/static-1.6163",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4368",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.58",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4243",
  "nav-client-types": "/nav-client-types/static-1.2051",
  "purchase-motions-api": "/purchase-motions-api/static-1.5359",
  "trials-service-types": "/trials-service-types/static-1.3644",
  "chatspot-client-types": "/chatspot-client-types/static-1.10377",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.445",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16799",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12600",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5302",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7508",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10091",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31014",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10737",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6257",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34578",
  "customer-data-tracking": "/customer-data-tracking/static-1.6581",
  "products-iframe-lib": "/products-iframe-lib/static-1.7133",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9662",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8329",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3874",
  "video-components-external": "/video-components-external/static-1.10337",
  "video-data-lib": "/video-data-lib/static-1.33995",
  "directed-graph": "/directed-graph/static-1.655",
  "event-emitter": "/event-emitter/static-1.644",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5208",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9363",
  "fsm": "/fsm/static-1.3451",
  "policy-lib": "/policy-lib/static-1.6520",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9426",
  "navigation-messaging": "/navigation-messaging/static-1.6377",
  "FileManagerLib": "/FileManagerLib/static-1.38314",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8825",
  "FileManagerCore": "/FileManagerCore/static-1.38173",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11899",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10874",
  "react-codemirror": "/react-codemirror/static-1.10325",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9608",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13510",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27752",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8285",
  "payment-link-components": "/payment-link-components/static-1.22732",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23799",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2925",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2715",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34803",
  "sales-views-client-types": "/sales-views-client-types/static-1.4013",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3378",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11177",
  "content-media-compositions": "/content-media-compositions/static-2.15184",
  "media-bridge-lib": "/media-bridge-lib/static-1.18448",
  "trellis-story-utils": "/trellis-story-utils/static-1.4241",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5502",
  "FileManagerImages": "/FileManagerImages/static-1.35825",
  "video-components": "/video-components/static-1.12340",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4252",
  "video-embed": "/video-embed/static-1.34829",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67486",
  "layout-data-lib": "/layout-data-lib/static-1.9199",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6304",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5602",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4808",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3421",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21165",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3562",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21132",
  "outpost": "/outpost/static-1.3931",
  "advanced-menus-core": "/advanced-menus-core/static-1.14689",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11678",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33236",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14688",
  "simple-menus-lib": "/simple-menus-lib/static-1.16205"
}
};
